import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'actionPlanStatus'
})
export class ActionPlanStatusPipe implements PipeTransform {

    actionPlanStatus = {
        LATE: 'delayed',
        PENDING: 'pending',
        DONE: 'done'
    };

    transform(actionPlan): any {
        const now = new Date();
        const date = new Date(actionPlan.deadline);

        if(actionPlan.status != 'DONE' && (date < now)) {
            return this.actionPlanStatus.LATE;
        }
        
        return this.actionPlanStatus[actionPlan.status];
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/action-plan-status.pipe.ts